export type MaintenanceState = {
  enabled: boolean;
  endTime?: string;
};

export type GetMaintenanceStatusOptions = {
  signal?: AbortSignal;
};

type MaintenanceResponse = {
  enabled: boolean;
  endTime?: string | null;
};

export async function getMaintenanceStatus(
  url: string,
  { signal }: GetMaintenanceStatusOptions = {},
): Promise<MaintenanceState | undefined> {
  try {
    const response = await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      signal,
    });

    if (!response.ok) {
      console.error('Failed to fetch maintenance status:', response.status, response.statusText);
      return undefined;
    }

    const data: unknown = await response.json();
    if (!isMaintenanceResponse(data)) {
      console.error('Invalid maintenance status response:', data);
      return undefined;
    }

    return data.endTime == null ? { enabled: data.enabled } : { enabled: data.enabled, endTime: data.endTime };
  } catch (error) {
    console.error('Failed to fetch maintenance status:', error);
    return undefined;
  }
}

function isMaintenanceResponse(value: unknown): value is MaintenanceResponse {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const candidate = value as Record<string, unknown>;
  const hasValidEndTime =
    candidate.endTime === undefined || candidate.endTime === null || typeof candidate.endTime === 'string';

  return typeof candidate.enabled === 'boolean' && hasValidEndTime;
}
